import { ReactElement, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Dropdown from 'components/v2/Dropdown'
import { DotsIcon } from 'components/Icons/DotsIcon'
import IconButton from 'components/v2/IconButton'
import List from 'components/v2/List'
import { PencilIcon } from 'components/Icons'
import { IRoutingProjectModel } from 'features/RoutingProjects/types'
import { CreateRoutingProjectModal } from 'features/RoutingProjects/components/CreateProjectModal'

interface IRoutingProjectActionsProps {
  routingProject: IRoutingProjectModel
}

export const RoutingProjectActions = ({ routingProject }: IRoutingProjectActionsProps): ReactElement => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)
  const [isOpenEditProjectModal, setIsOpenEditProjectModal] = useState(false)

  const toggleDropdown = (): void => {
    setOpenDropdown(!isOpenDropdown)
  }

  const openEditProjectModal = (): void => {
    setIsOpenEditProjectModal(true)
  }

  return (
    <>
      <Dropdown.Wrapper noPadding noIndicator right onClickAway={(): void => setOpenDropdown(false)}>
        <IconButton icon={<DotsIcon />} noBorder smallPadding onClick={toggleDropdown} />
        <Dropdown.Content open={isOpenDropdown} noIndicator left noOverflow>
          <List.Container>
            <List.Item action onClick={openEditProjectModal}>
              <List.Icon>
                <PencilIcon />
              </List.Icon>
              <FormattedMessage id="dictionary.edit" defaultMessage="Edit" />
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>
      {isOpenEditProjectModal && (
        <CreateRoutingProjectModal
          routingProject={routingProject}
          closeModal={(): void => setIsOpenEditProjectModal(false)}
        />
      )}
    </>
  )
}
